<div class="exchange-rate">

    <div class="exchange-rate__item exchange-rate__rate">
        <div>
            <ins-input
                autosize
                data-testid="exchange-rate-unit-input"
                rtl="false"
                maxlength="4"
                class="exchange-rate__input exchange-rate__unit"
                inputmode="decimal"
                [precision]="unitPrecision"
                [ngModel]="unit"
                [sklValidateInner]="{key: validationKey, option: 'disable-control'}"
                (ngModelChange)="onUnitChange($event)">
            </ins-input>
            <span
                [sklValidateInner]="{key: validationKey, option: 'disable'}"
                role="text"
                data-testid="exchange-rate-unit-label"
                class="exchange-rate__text">
                {{ unitCurrency }}
            </span>
        </div>

        <div>
            <span
                [sklValidateInner]="{key: validationKey, option: 'disable'}"
                data-testid="exchange-rate-equality-label"
                role="text" class="exchange-rate__text">
                &#160;=
            </span>
            <ins-input
                autosize
                rtl="false"
                maxlength="10"
                class="exchange-rate__input"
                data-testid="exchange-rate-rate-input"
                inputmode="decimal"
                [sklValidateInner]="{key: validationKey, option: 'disable-control'}"
                [precision]="ratePrecision"
                [ngModel]="rate"
                (ngModelChange)="onRateChange($event)">
            </ins-input>
            <span
                [sklValidateInner]="{key: validationKey, option: 'disable'}"
                data-testid="exchange-rate-rate-label"
                role="text"
                class="exchange-rate__text">
                {{ rateCurrency }}
            </span>
        </div>
    </div>

    @if (date) {
        <div class="exchange-rate__item exchange-rate__date">
            <span
                [sklValidateInner]="{key: validationKey, option: 'disable'}"
                data-testid="exchange-rate-day-label"
                role="text"
                class="exchange-rate__text">
                &#160;{{ 'scenes.shared.control.exchange-rate.from-day' | translate }}&#160;
            </span>
            <ins-datepicker
                #datepicker
                class="exchange-rate__input"
                data-testid="exchange-rate-day-input"
                [ngModel]="date"
                (ngModelChange)="onDateChange($event)"
                [sklValidate]="validationKey">
            </ins-datepicker>
        </div>
    }
</div>
